<template>
  <div class="about">
      <transition-group>
        <div class="card mx-auto my-5 shadow" style="min-width: 18rem; max-width: fit-content;overflow: auto;" v-if="showModal">
          <div class="card-body">
            <h5 class="card-title">
               Payee Entity Data
            </h5>
            <button type="button" class="btn-close position-absolute fs-4" aria-label="Close" style="right: 5px;top: 5px;" @click.prevent="showModal=false"></button>
            <div class="contain">
              <p class="card-text text-danger italic">Any changes done here will reflect only invoices generated after the change was applied.</p>
              <div class="row" v-for="r,index in Object.keys(rowData).filter(item => !hidden.includes(item))" :key="index">
                <float-select   v-if="r=='type'" :options="typeOptions" v-model="rowData[r]" :disabled="disabled.includes(r)" :ogDataSrc="typeOptions.find((b)=>{return b.id==rowData[r]})"
                                list-mode="Object"  :label="headers[r]" label-class="text-dark fw-bold" option-class="bg-primary-subtle bg-gradient"
                                            />
                <float-inp v-else type="text" :label="headers[r]" v-model="rowData[r]" class="col-12 px-1 mb-1" :disabled="disabled.includes(r)"
                label-class="text-dark fw-bold" input-class="bg-primary-subtle bg-gradient input" />
              </div>
            </div>
            <a href="#" v-if="rowData['id']===null || rowData['id']<1" class="btn btn-primary" @click.prevent="requestActionCaptcha({ title: 'Confirm Create', promptText: 'Solve the sum to create this payee entity record.', confirmLabel: 'Create', action: () => postPayeeEntity('post') })" >Create Entity</a>
            <template v-else>
              <a href="#" class="btn btn-warning me-2" @click.prevent="requestActionCaptcha({ title: 'Confirm Duplicate', promptText: 'Solve the sum to duplicate this payee entity record.', confirmLabel: 'Duplicate', action: () => duplicateCurrentRecord() })" >Duplicate</a>
              <a href="#" class="btn btn-success me-2" @click.prevent="requestActionCaptcha({ title: 'Confirm Update', promptText: 'Solve the sum to update this payee entity record.', confirmLabel: 'Update', action: () => postPayeeEntity('put') })" >Update Entity</a>
              <button type="button" class="btn btn-outline-danger" @click.prevent="requestActionCaptcha({ title: 'Confirm Delete', promptText: 'Solve the sum to delete this payee entity record.', confirmLabel: 'Delete', action: () => deleteCurrentRecord() })">
                <i class="bi bi-trash3 me-1"></i>
                Delete
              </button>
            </template>
          </div>
        </div>        
        <cdTable :links="links" title="Payee Entities" table-name="pentity" :hidden="hidden" :headers="headers" :gen-form="false" v-else @popForm="e=>setRowData(e)" ></cdTable>
        <ActionCaptchaModal
          :show="showActionCaptcha"
          :title="captchaTitle"
          :prompt-text="captchaPromptText"
          :confirm-label="captchaConfirmLabel"
          @close="closeActionCaptcha"
          @confirmed="confirmActionCaptcha"
        />
      </transition-group>
      <!-- <transition>
      </transition> -->
      
    </div>
  </template>
  <script>
  import cdTable from '@/components/cddatatables/cdTable.vue';
  import floatInp from '@/parts/floatInp.vue';
  import floatSelect from '@/parts/floatSelect.vue';
  import ActionCaptchaModal from '@/components/mods/ActionCaptchaModal.vue';
  import { payeeEntityLinks } from '@/cd-links';
  export default{
    components:{
      cdTable, floatInp, floatSelect, ActionCaptchaModal
    },
    data(){
      return {
        links: payeeEntityLinks,
        headers:{
              id:"ID",
              name: "Name",
              nickname: "Nickname",
              type: "Type",
              description: "Description",
              pan: "PAN",
              gst: "GST",
              tax_details: "Tax_Details",
              address: "Address",
              contact_no: "Contact No.",
              email: "Email",
              createdAt:"Created On",
              updatedAt:"Updated On"
          },
          hidden:[
            'creatorId',
            /* 'updatedAt',
            'createdAt', */
            'status',
            'invoice_temp_id',
            'ent_id'
          ],
          disabled:['id'],
          showModal:false,
          rowData:{
              name: null,
              nickname: null,
              type: null,
              description: null,
              pan: null,
              gst: null,
              tax_details: null,
              address: null,
              contact_no: null,
              email: null,
          },
          typeOptions:[
            {id:"Person",name:"Person"},
            {id:"Company",name:"Company"}
          ],
          loading:false,
          showActionCaptcha: false,
          captchaTitle: 'Confirm Action',
          captchaPromptText: 'Please solve this quick check to continue.',
          captchaConfirmLabel: 'Confirm',
          pendingAction: null
      }
    },
    methods:{
      requestActionCaptcha({ title, promptText, confirmLabel, action }) {
        this.captchaTitle = title || 'Confirm Action';
        this.captchaPromptText = promptText || 'Please solve this quick check to continue.';
        this.captchaConfirmLabel = confirmLabel || 'Confirm';
        this.pendingAction = typeof action === 'function' ? action : null;
        this.showActionCaptcha = true;
      },
      closeActionCaptcha() {
        this.showActionCaptcha = false;
        this.pendingAction = null;
      },
      confirmActionCaptcha() {
        const action = this.pendingAction;
        this.showActionCaptcha = false;
        this.pendingAction = null;
        if (typeof action === 'function') action();
      },
      duplicateCurrentRecord(){
        const duplicated = JSON.parse(JSON.stringify(this.rowData || {}));
        duplicated.id = null;
        this.rowData = duplicated;
      },
      async deleteCurrentRecord(){
        if (!this.rowData?.id || this.rowData.id < 1) return;

        try {
          const resp = await this.$store.getters.getAxios(this.links.delItem, {
            method: 'delete',
            data: { id: this.rowData.id }
          });

          if (resp.data.isLoggedIn) {
            this.$store.commit('addAlert', {
              title: resp.data.title,
              message: resp.data.msg,
              type: resp.data.success ? 'info' : 'danger'
            });
            if (resp.data.success) this.showModal = false;
          } else {
            this.$store.dispatch('loggedOut');
          }
        } catch (err) {
          this.$store.commit('addAlert', {
            title: 'Error',
            message: err.response?.data?.msg || err.message || 'Error deleting payee entity',
            type: 'danger'
          });
        }
      },
      async postPayeeEntity(mode){
        try {
          this.loading=true;
          this.rowData.status=true;
          this.rowData['ent_id']=this.$store.getters.getEntity;
          
          // Validate type is selected
          if(!this.rowData.type) {
            this.$store.commit('addAlert', {
              title: "Validation Error",
              message: "Please select a Type",
              type: 'warning'
            });
            this.loading=false;
            return;
          }
          
          // Transform type to name
          this.rowData.type = typeof this.rowData.type === 'object' ? this.rowData.type.name : this.rowData.type;
          
          await this.$store.getters.getAxios(this.links[mode],{method:mode,data:this.rowData})
              .then(resp=>{

                if(resp.data.isLoggedIn){
                  this.$store.commit('addAlert', {
                        title: resp.data.title,
                        message: resp.data.msg,
                        type: resp.data.success? 'info' : 'danger'
                    });
                  resp.data.success? this.showModal=false : this.showModal=true;                            
                  }
                else this.$store.dispatch('loggedOut');
              })
              .catch(err=>{
                console.error('Error posting payee entity:', err);
                this.$store.commit('addAlert', {
                  title: "Error",
                  message: err.response?.data?.msg || err.message || "Error saving payee entity",
                  type: 'danger'
                });
              })
              .finally(() => {
                this.loading=false;
              })
        } catch(err) {
          console.error('Error in postPayeeEntity:', err);
          this.$store.commit('addAlert', {
            title: "Error",
            message: err.message || "Error processing form",
            type: 'danger'
          });
          this.loading=false;
        }
      },
      setRowData(e){
        this.rowData=e.rowData;
        this.showModal=true;
      },
      async getDropDownData(table,colName) {
                    this.loading=true;
                    await this.$axios.post(this.ddLinks,{table:table,colName:colName})
                        .then(resp=>{
                            this.ddHolder[table] =  JSON.parse(resp.data.data);
                            this.ddList.forEach(e=>{
                                if(e.depsOn==null)this.getDropDownData(e.table,e.colName);
                            });
                        })
                        // eslint-disable-next-line
                        .catch(err=>{
                            this.$store.commit('addAlert', {
                                title: "Error Getting Data",
                                message: "Try after some time",
                                type: 'danger'
                            });
        
                        })
                },
      
    }
  }
  </script>
  